export default "__VITE_ASSET__Bnec6TsA__"